// libs
import isEmpty from 'lodash/isEmpty';

// constants
import { KNOW_YOUR_PRODUCT_TITLE } from 'shared/layouts/DetailsPage/constants';
import { WIDGET_TYPES } from 'shared/layouts/DetailsPage/components/ProductInfo/components/ProductDescription/constants';
import { KYP01_WIDGET_ID } from './constants';

export type ProductAeoFaqItem = { que: string; ans: string };

export const isKnowYourProductWidget = (widget?: {
  widget_id?: string;
  title?: string;
} | null): boolean =>
  Boolean(
    widget &&
    (widget.widget_id === KYP01_WIDGET_ID || widget.title === KNOW_YOUR_PRODUCT_TITLE)
  );

export const getValidFaqItems = (
  faq?: ProductAeoFaqItem[] | null
): ProductAeoFaqItem[] => (faq || []).filter((item) => item?.que && item?.ans);

export const shouldShowProductAeoFaq = (
  widget?: {
    widget_id?: string;
    title?: string;
    widget_type?: string;
    faq?: ProductAeoFaqItem[] | null;
  } | null,
  isAeoFaqEnabled = false
): boolean =>
  Boolean(
    isAeoFaqEnabled &&
    isKnowYourProductWidget(widget) &&
    widget?.widget_type === WIDGET_TYPES.plainCollapsableWidget &&
    !isEmpty(getValidFaqItems(widget?.faq))
  );
